import { Route, Redirect } from "react-router-dom";
import authService from "../_services/auth.service";

export default function DriverPrivateRoute({
	component: Component,
	children,
	render,
	...rest
}) {
	const user = authService.currentUser();
	return (
		<Route
			{...rest}
			render={({ location }) =>
				user && user?.role === "driver" ? (
					children
				) : (
					<Redirect
						to={{
							pathname: "/",
							state: { from: location },
						}}
					/>
				)
			}
		/>
	);
}
